import Breadcrumb from "../components/Breadcrumb";
import CarListingStatusLayer from "../components/child/CarListingStatusLayer"

const CarListingRejected = () => {
  return (
    <>
        {/* Breadcrumb */}
        <Breadcrumb title='Rejected Car Listing' />

        {/* <AnnouncementLayer /> */}
        <CarListingStatusLayer approvalStatusFilter="rejected" />
    </>
  );
};

export default CarListingRejected;




